import { format, parseISO } from 'date-fns';
import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import { buildImageObj, imageUrlFor } from './sanity/image-url';
import BlockContent from './sanity/block-content';
import SocialShare from './social/social-share';
import BlogTeaser from './blog-teaser';
import SlideDeck from './slideDeck';

function BlogFull(props) {
  return (
    <>
      <article className="container article article--lg push-top">
        <div className="row">
          <div className="col-sm-12 order-sm-2">
            <div className="gutter-left gutter-right">
              <div className="social-buttons social-buttons--vertical">
                <SocialShare prefix='/perspectives/' slug={props.slug} title={props.title} />
              </div>
              <figure className="article__media">
                {props.embed ? (
                  <div className="flex-media" id="youtubevideo">
                    <div dangerouslySetInnerHTML={{ __html: props.embed }} />
                  </div>
                ) : (
                    props.image && props.image.asset && (
                      <img
                        src={imageUrlFor(buildImageObj(props.image))
                          .width(1382)
                        }
                      />
                    )
                  )}
                {props.caption && (
                  <figcaption className="article__figcaption">
                    {props.caption}
                  </figcaption>
                )}
              </figure>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 col-md-10 offset-md-1 col-lg-9 offset-lg-2">
            <div className="article__content gutter-left gutter-right">

              {props.file && (
                <p className="article__source">
                  <a href={props.file.asset.url} className="btn btn-outline-primary" target="_blank">{props.downloadButton ? props.downloadButton : 'Download File'}</a>
                </p>
              )}

              {props.sourceName && (
                <div className="article__source-name">
                  {props.sourceName}
                </div>
              )}

              <header className="article__header">
                <h1 className="article__title">
                  {props.title}
                </h1>

                <div className="article__datetime">
                  {props.publishedAt && (<p>{format(parseISO(props.publishedAt), 'EEEE, MMMM do yyyy')}</p>)}
                </div>
              </header>

              {props.bodyMarkdown && (
                <div className="article__body">
                  <ReactMarkdown source={props.bodyMarkdown} escapeHtml={false} />

                  {props.slideDeck && props.slideDeck.length > 0 && (
                    <SlideDeck deck={props.slideDeck[0]} />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </article>

      {props.relatedBlogs.length > 0 && (
        <div className="container recommended-reading" >
          <div className="row" >
            <div className="col-sm-10 offset-sm-1" >
              <h1 className="recommended-reading__headline" > Recommended Reading </h1>
              <hr className="primary" />
            </div>
          </div>

          <div className="row">
            {props.relatedBlogs.map((node, index) => (
              <div className={`col-sm-5 ${index % 2 ? "" : "offset-sm-1 col-border-right"}`} key={node.id}>
                <div className={`article-recommended article-recommended--${index % 2 ? "right" : "left"}`}>
                  <BlogTeaser {...node} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>

  );
}

export default BlogFull;
